/* eslint-disable no-restricted-imports */
import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ModalProgressBar } from '../../../../../_metronic/_partials/controls';
import * as actions from '../../_redux/deliveries/deliveriesActions';
import { useDeliveriesUIContext } from '../DeliveriesUIContext';

export function DeliverDeleteDialog({ id, show, onHide }) {
  // Deliveries UI Context
  //console.log("DeliverDeleteDialog", id);
  const deliveriesUIContext = useDeliveriesUIContext();
  const deliveriesUIProps = useMemo(() => {
    return {
      setIds: deliveriesUIContext.setIds,
      queryParams: deliveriesUIContext.queryParams,
    };
  }, [deliveriesUIContext]);
  //const [show, setShow] = useState(false);

  // Deliveries Redux state
  const dispatch = useDispatch();
  const intl = useIntl();
  const titleText = intl.formatMessage({ id: 'DELIVERIES.CONFIRM.TITLE' });
  const questionText = intl.formatMessage({
    id: 'DELIVERIES.CONFIRM.DELETE.QUESTION',
  });
  const deleteButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.DELETE',
  });
  const cancelButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.CANCEL',
  });
  const loadingText = intl.formatMessage({
    id: 'DELIVERIES.CONFIRM.DELETE.LOADING',
  });
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.deliveries ? state.deliveries.actionsLoading : false,
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    /*  if(match){
      setShow( true);
    } */
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteDeliver = () => {
    // server request for deleting deliver by id
    dispatch(actions.deleteDeliver(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchDeliveries(deliveriesUIProps.queryParams));
      // closing delete modal
      // clear selections list
      //deliveriesUIProps.setIds([]);
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      {isLoading && <ModalProgressBar variant='query' />}
      <Modal.Header closeButton>
        <Modal.Title id='Deliverexample-modal-sizes-title-lg'>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>
            {' '}
            <b>{id}</b> {questionText}
          </span>
        )}
        {isLoading && <span>{loadingText}</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'
          >
            {cancelButtonText}
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteDeliver}
            className='btn btn-primary btn-elevate'
          >
            {deleteButtonText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
